import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/general";
import TODIS_FORM_INFRA from "./form/NRAILS/infrastructure";
import TODIS_FORM_OPS from "./form/NRAILS/operations";
import TODIS_FORM_TENT_COMP from "./form/NRAILS/tent_compliance";
import TODIS_FORM_SAFTEY from "./form/NRAILS/safety";
import TODIS_FORM_MAINT from "./form/NRAILS/maintenace";
import TODIS_FORM_ENV from "./form/GENERAL/environment";
import TODIS_FORM_CLIMATE from "./form/NRAILS/climate_resilience";
import { TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_OTHER_RAILWAYS from "./form/NRAILS/other";
import { loadModules } from 'esri-loader';



const TODIS_NRAIL_FORM = ({ errors, touched, status, setFieldValue, values }) => {

    const [statusRail, setStatusRail] = useState(true)
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)


    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/23";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `npm_rw_id=${values.npmRwId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })


    useEffect(() => {
        if (values.tenTCategory == "4") {// Core 
            if ((values.railwaysNpmInfraDTO.maxAxleLoad * 0.10197) >= 22.5) {
                setFieldValue('railwaysNpmTentcompDTO.freightLineAxleLoad', "true")
            } else {
                setFieldValue('railwaysNpmTentcompDTO.freightLineAxleLoad', "false")
            }
        } else {
            setFieldValue('railwaysNpmTentcompDTO.freightLineAxleLoad', "")
        }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.maxAxleLoad])

    useEffect(() => {
        if (values.tenTCategory == "4") {// Core 
            if ((values.railwaysNpmInfraDTO.maxTrainLength * 0.10197) >= 22.5) {
                setFieldValue('railwaysNpmTentcompDTO.freightLineTrainLength', "true")
            } else {
                setFieldValue('railwaysNpmTentcompDTO.freightLineTrainLength', "false")
            }
        } else {
            setFieldValue('railwaysNpmTentcompDTO.freightLineTrainLength', "")
        }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.maxTrainLength])

    useEffect(() => {
        if (values.tenTCategory == "Core") {// Core 
            if (values.railwaysNpmInfraDTO.trackGauge == '1435') { // 1435
                setFieldValue('railwaysNpmTentcompDTO.trackGauge1435Mm', "true")
            } else {
                setFieldValue('railwaysNpmTentcompDTO.trackGauge1435Mm', "false")
            }
        } else {
            setFieldValue('railwaysNpmTentcompDTO.trackGauge1435Mm', "")
        }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.trackGauge])

    useEffect(() => {
        if (values.railwaysNpmInfraDTO.ertms == "true") {
            setFieldValue('railwaysNpmTentcompDTO.ertmsDeployEtcs', true)
        } else {
            setFieldValue('railwaysNpmTentcompDTO.ertmsDeployEtcs', false)
        }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.trackGauge])

    useEffect(() => {
        if (values.railwaysNpmInfraDTO.lengthTunnels == 0) {
            setFieldValue('railwaysNpmTentcompDTO.rwTunnelComp', "")
            setStatusRail(true)
        } else {
            setStatusRail(false)
        }

    }, [values.railwaysNpmInfraDTO.lengthTunnels])

    useEffect(() => {
        if(values.tenTCategory != null && values.tenTCategory == "Core") {
            if (values.railwaysNpmInfraDTO.loadingGauge5400 == "true") { // 1435
                setFieldValue('railwaysNpmTentcompDTO.loadingGauge', "true");
            } else {
                setFieldValue('railwaysNpmTentcompDTO.loadingGauge', "false");
            }
        } else if(values.tenTCategory != null && values.tenTCategory == "Comprehensive") {
            
            setFieldValue('railwaysNpmTentcompDTO.loadingGauge', "")
        }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.loadingGauge5400])

        useEffect(() => {
            if(values.tenTCategory != null && values.tenTCategory == "Core") {
                if (values.railwaysNpmInfraDTO.maxDwellingTimeCrossBorder25 == "true") { // 1435
                    setFieldValue('railwaysNpmTentcompDTO.maxDwellingTimeCrossBorder25', "true");
                } else {
                    setFieldValue('railwaysNpmTentcompDTO.maxDwellingTimeCrossBorder25', "false");
                } 
            }
            else if(values.tenTCategory != null && values.tenTCategory == "Comprehensive"){
                setFieldValue('railwaysNpmTentcompDTO.maxDwellingTimeCrossBorder25', "");
            }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.maxDwellingTimeCrossBorder25])

        useEffect(() => {
            if(values.tenTCategory != null && values.tenTCategory == "Core") {
                if (Number(values.railwaysNpmInfraDTO.maxLongGradDirA) > 12.5 || Number(values.railwaysNpmInfraDTO.maxLongGradDirB) > 12.5) { // 1435
                    setFieldValue('railwaysNpmTentcompDTO.strongInclines', "true");
                } else{
                    setFieldValue('railwaysNpmTentcompDTO.strongInclines', "false");
            } 
            } else if(values.tenTCategory != null && values.tenTCategory == "Comprehensive") {
                setFieldValue('railwaysNpmTentcompDTO.strongInclines', "");
         }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.maxLongGradDirA, values.railwaysNpmInfraDTO.maxLongGradDirB])

    useEffect(() => {
        if(values.tenTCategory != null && values.tenTCategory == "Core") {// Core
            if (values.railwaysNpmInfraDTO.maxDesignSpeed != null && Number(values.railwaysNpmInfraDTO.maxDesignSpeed) >= 160) { // 1435
                setFieldValue('railwaysNpmTentcompDTO.passengerDesignSpeed160', "true")
            } else {
                setFieldValue('railwaysNpmTentcompDTO.passengerDesignSpeed160', "false");
            } 
        } else if(values.tenTCategory != null && values.tenTCategory == "Comprehensive") {
            setFieldValue('railwaysNpmTentcompDTO.passengerDesignSpeed160', "")
        }

    }, [values.tenTCategory, values.railwaysNpmInfraDTO.maxDesignSpeed])

    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const infraTooltip = (
        <Tooltip id="infra-tooltip">
            Infrastructure characteristics
        </Tooltip>
    );

    const tentTooltip = (
        <Tooltip id="tent-tooltip">
            Compliance with the relevant TEN-T standards
        </Tooltip>
    );

    const operationsTooltip = (
        <Tooltip id="operations-tooltip">
            Operations related data
        </Tooltip>
    );

    const safetyTooltip = (
        <Tooltip id="safety-tooltip">
            Safety related data
        </Tooltip>
    );

    const maintTooltip = (
        <Tooltip id="maint-tooltip">
            Maintenance related data
        </Tooltip>
    );

    const environmentTootltip = (
        <Tooltip id="environment-tooltip">
            Environment related data
        </Tooltip>
    );

    const climateTootltip = (
        <Tooltip id="climate-tooltip">
            Climate related data
        </Tooltip>
    );

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );



    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title={
                <OverlayTrigger placement="bottom" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" TetCategory="tenTCategory" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="section 3" title={
                <OverlayTrigger placement="bottom" overlay={infraTooltip}>
                    <div>Infrastructure</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_INFRA errors={errors} touched={touched} disabled={status} sectionData={values.railwaysNpmInfraDTO} setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="TENT" title={
                <OverlayTrigger placement="bottom" overlay={tentTooltip}>
                    <div>TEN-T Compliance</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_TENT_COMP errors={errors} touched={touched} disabled={status} statusRail={statusRail} values={values} />
            </Tab>
            <Tab eventKey="Operations" title={
                <OverlayTrigger placement="bottom" overlay={operationsTooltip}>
                    <div>Operations</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_OPS errors={errors} touched={touched} disabled={status} />
            </Tab>
            <Tab eventKey="Safety" title={
                <OverlayTrigger placement="bottom" overlay={safetyTooltip}>
                    <div>Safety</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_SAFTEY errors={errors} touched={touched} disabled={status} />
            </Tab>
            <Tab eventKey="Maintenance" title={
                <OverlayTrigger placement="bottom" overlay={maintTooltip}>
                    <div>Maintenance</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_MAINT errors={errors} touched={touched} disabled={status} />
            </Tab>
            <Tab eventKey="Environmental" title={
                <OverlayTrigger placement="bottom" overlay={environmentTootltip}>
                    <div>Environmental Impact</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ENV errors={errors} touched={touched} disabled={status} TypeForm="railwaysNpmEnvDTO" />
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Climate" title={
                <OverlayTrigger placement="bottom" overlay={climateTootltip}>
                    <div>Climate resilience</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_CLIMATE errors={errors} touched={touched} disabled={status} />
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_RAILWAYS errors={errors} touched={touched} disabled={status} TypeForm="railwaysNpmOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>

    )
}

export default TODIS_NRAIL_FORM;